/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react'
import uniqueId from 'lodash/uniqueId'
import ToolTipOverlayComponent from '../../Components/ToolTipOverlay'
import './styles.scss'

export interface CustomRadioProps {
  id?: string
  value: string
  schema: any
  updateValue: any
  path: string
  data: any
  label: any
  errors: string
  visible: boolean
  uischema: any
  enabled: boolean
}

export const RadioControl: React.FC<CustomRadioProps> = ({
  id,
  value,
  updateValue,
  schema,
  label,
  errors,
  visible,
  uischema,
  enabled
}) => {
  const [radioId] = useState(() => uniqueId('radio-'))
  const onChange = (value: any) => {
    updateValue(value.target.value)
  }

  const getClass = () => {
    return errors && errors === 'is a required property'
      ? 'invalid-radio-input'
      : ''
  }

  return (
    <>
      {visible && (
        <div style={{ textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <label htmlFor={id} className='custom-input-label'>
              {label}
            </label>
            {uischema.toolTipText && (
              <ToolTipOverlayComponent
                toolTipText={uischema.toolTipText}
                placement='top'
                trigger='click'
              />
            )}
          </div>

          <div className='custom-radio-container'>
            {schema?.enum.map((option: any) => (
              <div key={option.name} className='radio-container'>
                <input
                  type='radio'
                  id={`${radioId}-${option.value}`}
                  key={option.name}
                  checked={value === option.value}
                  value={option.value}
                  onChange={onChange}
                  className={getClass()}
                  disabled={!enabled}
                />
                <label
                  htmlFor={`${radioId}-${option.value}`}
                  className='radio-label'
                >
                  {option.value}
                </label>
              </div>
            ))}
            {errors && errors === 'is a required property' && (
              <div className='text-danger'>
                <span>Please select an option</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
